import { all } from 'redux-saga/effects';
import authWatcher from './auth/sagas';

export default function* () {
  return yield all([authWatcher()]);
}
